// One session, one row (Josh 10-07; the Mac's glance does the same, GlanceClaude.swift): a conversation whose Terminal
// continuation is running is ONE row on Home — the original's id and title, "ready while locked" on its line, the
// continuation's state when it is working or waiting. The Claude Code extension still lists the continuation as its
// own row with `continues: <original's id>`; here the pair folds into the original, and a tap opens the original (the
// Mac sends its prompts into the terminal). A continuation whose original isn't listed stays as it is.
//
// One seam: `collapseContinuations(items)` — items as extensions.js homeRows gives them ({ext, extName, row}), live or
// from the offline snapshot. No DOM: tools/tests/web-home-groups.mjs.
export const READY_WHILE_LOCKED = 'ready while locked'
const RANK = { needsYou: 3, live: 2, idle: 1, ended: 0 }

export function collapseContinuations(items = []) {
  const ids = new Set(items.map((x) => String(x?.row?.id)))
  const into = new Map()   // original id → its continuation's row
  for (const x of items) { const c = x?.row?.continues; if (c != null && ids.has(String(c))) into.set(String(c), x.row) }
  if (!into.size) return items
  const out = []
  for (const x of items) {
    if (x?.row?.continues != null && into.get(String(x.row.continues)) === x.row) continue   // folded into its original
    const cont = into.get(String(x?.row?.id))
    if (!cont) { out.push(x); continue }
    const row = { ...x.row, subtitle: [x.row.subtitle, READY_WHILE_LOCKED].filter(Boolean).join(' · '), continuedBy: String(cont.id) }
    if ((RANK[cont.status] ?? 0) > (RANK[row.status] ?? 0)) row.status = cont.status
    if (cont.time && (!row.time || cont.time > row.time)) row.time = cont.time
    out.push({ ...x, row })
  }
  return out
}
